import { Row, Col } from "antd";
import DashboardPainrating from "./../components/dashboardPainrating";
import DashboardReliefMethods from "./../components/dashboardReliefMethods";
import DashboardPainEnergyMoodHeatmap from "./../components/dashboardPainEnergyMoodHeatmap";
import DashboardPainLocationDetails from "./../components/dashboardPainLocationDetails";
import DashboardPainEntryDatatable from "./../components/dashboardPainEntryDatatable";
import DashboardFreqPainTriggers from "./../components/dashboardFreqPainTriggers";
import DashboardSymptomTracking from "./../components/dashboardSymptomTracking";

const DashboardPage = () => {
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12} xl={12} xxl={12} lg={12}>
          <DashboardPainrating />
        </Col>
        <Col xs={24} md={12} xl={12} xxl={12} lg={12}>
          <DashboardReliefMethods />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24}>
          <DashboardPainEnergyMoodHeatmap />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24}>
          <DashboardPainLocationDetails />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24}>
          <DashboardPainEntryDatatable />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <DashboardFreqPainTriggers />
        </Col>
        <Col xs={24} lg={12}>
          <DashboardSymptomTracking />
        </Col>
      </Row>
    </>
  );
};

export default DashboardPage;
